import { Component, OnInit } from '@angular/core';
import { TempoDeEsperaService } from '../services/tempo-de-espera/tempo-de-espera.service';
import { FormGroup, FormControl, Validators } from '@angular/forms';

@Component({
    selector: 'spe-timeout',
    templateUrl: './timeout.component.html',
    styleUrls: ['./timeout.component.scss'],
    standalone: false
})
export class TimeoutComponent implements OnInit {
  public mainFormGroup = new FormGroup({
    time: new FormControl(1000)
  });
  constructor(private tempoDeEsperaService: TempoDeEsperaService) {}

  ngOnInit(): void {}

  public timeout = () => {
    this.tempoDeEsperaService.get(this.mainFormGroup.value.time!).subscribe({
      next: (response) => {
        console.log(response);
      },
      error: (error) => {
        console.log(error);
      }
    });
  };
}
